import React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { ESRFieldProps } from "../../types/data";
import { useRemoteField } from "../../hooks/useRemoteField";
import { Checkbox } from "@mui/material";

export const ESRBooleanField = (props: ESRFieldProps) => {
	const { question_id, locked, inline, hint_value, show_initial_response } = props;
	const [value, setValue] = useRemoteField(question_id);

	const handleChange = (newVal: string) => {
		setValue(newVal, locked === -1);
	};
	return (inline && !question_id.startsWith("C42B.") && !question_id.startsWith("C101."))  ? (
		<Checkbox
			id={question_id}
			disabled={locked > 0}
			checked={value === "True"}
			onChange={(e) => handleChange(e.target.checked ? "True" : "False")}
		/>
	) : (
		<RadioGroup
			id={question_id}
			aria-labelledby={question_id}
			row
			value={value ?? ""}
			onChange={(e) => handleChange(e.target.value)}
		>
			<FormControlLabel
				disabled={locked > 0}
				value="True"
				control={
					<Radio />
				}
				label="Yes"
				sx={{
					color:
						hint_value === "True" && value === "" && show_initial_response == "x"
							? "secondary.main"
							: "inherit",
					"& .MuiTypography-root": {
						color:
							hint_value === "True" && value === "" && show_initial_response == "x"
								? "secondary.main"
								: "inherit",
					},
					"& .MuiButtonBase-root": {
						color:
							hint_value === "True" && value === "" && show_initial_response == "x"
								? "secondary.main"
								: "primary",
					},
				}}
			/>
			<FormControlLabel
				disabled={locked > 0}
				value="False"
				control={
					<Radio />
				}
				label="No"
				sx={{
					color:
						hint_value === "False" && value === "" && show_initial_response == "x"
							? "secondary.main"
							: "inherit",
					"& .MuiTypography-root": {
						color:
							hint_value === "False" && value === "" && show_initial_response == "x"
								? "secondary.main"
								: "inherit",
					},
					"& .MuiButtonBase-root": {
						color:
							hint_value === "False" && value === "" && show_initial_response == "x"
								? "secondary.main"
								: "primary",
					},
				}}
			/>
		</RadioGroup>
	);
};